import { action } from 'easy-peasy';
import { IActionRemoveCarePlanIntervention } from '../types';

const removeCarePlanIntervention: IActionRemoveCarePlanIntervention = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeCarePlanIntervention;
